export default __webpack_public_path__ + "static/media/3.ca70bc6b.mp3";